import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ProductDabItemComponent } from './components/product-dab-item/product-dab-item.component';

@NgModule({
  imports: [CommonModule, IconsModule],
  declarations: [ProductDabItemComponent],
  exports: [ProductDabItemComponent],
})
export class ProductDabModule {}
